/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type address_content = {
    /**
     * Bech32 encoded addresses
     */
    address: string;
    amount: Array<{
/**
 * The unit of the value
 */
unit: string;
/**
 * The quantity of the unit
 */
quantity: string;
}>;
    /**
     * Stake address that controls the key
     */
    stake_address: string | null;
    /**
     * Address era
     */
    type: address_content.type;
    /**
     * True if this is a script address
     */
    script: boolean;
};

export namespace address_content {

    /**
     * Address era
     */
    export enum type {
        BYRON = 'byron',
        SHELLEY = 'shelley',
    }


}
